import { mapGetters } from 'vuex'
import util from '../../util'
import { withLiveParticipant } from './replayLink'

export default {
  computed: {
    ...mapGetters('replay', ['retake']),
    retakeNeedsLogin() {
      const { currentUser, isLoadingCurrentUser } = this.$store.state
      const isSignedIn = !!(currentUser && currentUser.id)
      // A white-label domain cannot read the sign-in cookie, so asking would loop forever; a profile still loading means signed in.
      return !isSignedIn && !isLoadingCurrentUser && !util.checkWhiteLabelDomain()
    },
  },
  methods: {
    retakeTrackingPayload(touchpoint) {
      const { presentation } = this.$store.state
      return {
        presentationId: presentation && presentation.id,
        sessionId: this.retake && this.retake.sessionId,
        source: this.retake && this.retake.source,
        touchpoint,
      }
    },
    retakeLink() {
      return withLiveParticipant(this.retake.replayUrl, this.$store.state.audienceId)
    },
    startRetake(touchpoint) {
      if (!this.retake) return
      util.ga4Track('click_replay_practise_again', this.retakeTrackingPayload(touchpoint))
      if (this.retakeNeedsLogin) {
        this.$store.commit('replay/openRetakeLogin', touchpoint)
        util.ga4Track('view_replay_login', this.retakeTrackingPayload(touchpoint))
        return
      }
      window.open(this.retakeLink(), '_blank', 'noopener')
    },
  },
}
